<style lang="scss" scoped>

</style>

<template>
    <Alert type="danger" :show="show" >
        <template v-slot:title>Wollen Sie den Wasserzählersensors wirklich entfernen?</template>
        <div>
            Durch das Entfernen des Wasserzählersensors bleiben alle bis dahin importierten Entnahmen erhalten. 
            Neue Entnahmen über den Wasserzählersensor werden nicht mehr dokumentiert.
        </div>
        
        <div class="mt-3 mb-0">
            <button type="button" class="btn me-auto" @click="this.$emit('cancel')">
                Abbrechen
            </button>
            <button type="button" class="btn btn-info ms-auto float-end" @click="this.$emit('confirm')">
                Entfernen
            </button>
        </div>
      
    </Alert>
</template>

<script>
import Alert from '@/components/Alert.vue';

export default {
    name: 'ConfirmRemoveFromProfile',
    components: {
        Alert
    },
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },
    emits: [
        'confirm',
        'cancel'
    ],
    data: function() {
        return {
            
        }
    },
    computed: {
        
    },
    methods: {
        confirm: function () {
            this.$emit('confirm');
        },
        cancel: function () {
            this.$emit('cancel');
        }
    }
}
</script>
